import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Teleport as _Teleport, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notification-bell-wrapper"
}
const _hoisted_2 = {
  class: "col-auto",
  style: {"padding-right":"0px","position":"relative"}
}
const _hoisted_3 = { class: "notification-icon" }
const _hoisted_4 = {
  key: 0,
  class: "notification-badge"
}
const _hoisted_5 = { class: "notifications-header" }
const _hoisted_6 = {
  key: 0,
  class: "unread-count-badge"
}
const _hoisted_7 = { class: "notifications-filter" }
const _hoisted_8 = {
  key: 0,
  class: "contact-filter-chip"
}
const _hoisted_9 = { class: "contact-filter-chip__avatar" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "contact-filter-chip__name" }
const _hoisted_12 = { class: "contact-filter-search" }
const _hoisted_13 = {
  key: 0,
  class: "contact-filter-search__spinner"
}
const _hoisted_14 = {
  key: 0,
  class: "contact-filter-empty"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "contact-filter-result-item__avatar" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { class: "contact-filter-result-item__info" }
const _hoisted_19 = { class: "contact-filter-result-item__name" }
const _hoisted_20 = {
  key: 0,
  class: "contact-filter-result-item__meta"
}
const _hoisted_21 = {
  key: 0,
  class: "notifications-loading"
}
const _hoisted_22 = {
  key: 1,
  class: "notifications-list"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "notification-icon-wrapper" }
const _hoisted_25 = {
  key: 0,
  class: "unread-indicator"
}
const _hoisted_26 = { class: "notification-content" }
const _hoisted_27 = { class: "notification-message" }
const _hoisted_28 = {
  key: 0,
  class: "notification-entity"
}
const _hoisted_29 = {
  key: 1,
  class: "notification-entity"
}
const _hoisted_30 = { class: "notification-footer" }
const _hoisted_31 = { class: "notification-time" }
const _hoisted_32 = { class: "notification-actions" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 0,
  class: "load-more-wrapper"
}
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 2,
  class: "no-notifications"
}

import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useToast } from "@/composables/ui/useToast";
import { Icon } from "@iconify/vue";
import LoadingBars from "@/components/ui/LoadingBars.vue";
import {
  BUCKETS_LIST_ROUTE,
  BUCKETS_ROUTE,
  CONTACT_OVERVIEW_ROUTE,
  CONTACTS_ROUTE,
  MEETINGS_ROUTE,
  SUBSCRIPTION_SUCCESS_ROUTE,
  SUBSCRIPTION_WALL_ROUTE,
} from "@/router/routes";
import { useNotifications } from "@/composables/notifications/useNotifications";
import { useContacts } from "@/composables/contacts/useContacts";
import { useMarkNotificationSeen } from "@/composables/notifications/useMarkNotificationSeen";
import { useGlobalFollowupModal } from "@/composables/bucket/useGlobalFollowupModal";
import { NotificationCategory } from "@/utils/enums";
import filters from "@/utils/filters";
import debounce from "lodash/debounce";
import type { ContactSearchResult } from "@/dtos/Contact.dto";

interface Props {
  route: string;
  account: {
    id: string;
    organizationId: string;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationBell',
  props: {
    route: {},
    account: {}
  },
  setup(__props: any) {

const formatNotificationTime = (value: string | undefined) => filters.getDateAndTime(value ?? "");

const props = __props;

const $toast = useToast();
const { openFollowupModal } = useGlobalFollowupModal();
const router = useRouter();
const route = useRoute();

const ENGAGEMENT_EVENT_TO_TASK_TYPE: Record<string, string> = {
  email_opened: "email",
  email_clicked: "email",
  linkedin_connection: "linkedIn",
  inmail_read: "linkedIn",
  linkedin_message_read: "linkedIn",
  whatsapp_message_read: "whatsApp",
  sms_received: "sms",
  call_conversation: "call",
  linkedin_message: "linkedIn",
  whatsapp_message: "whatsApp",
  email_received: "email",
};

const isEngagementNotification = (n: any) =>
  !!n.contactId && !!n.meta?.eventType && n.meta.eventType in ENGAGEMENT_EVENT_TO_TASK_TYPE;

const isBucketPromptNotification = (n: any) =>
  n.type === NotificationCategory.task &&
  !!n.contactId &&
  !n.meta?.eventType &&
  n.message?.toLowerCase().includes("call with");

const isCueCardsNotification = (n: any) =>
  n.type === NotificationCategory.ai_generation && !!n.contactId;

const isMentionNotification = (n: any) => n.type === NotificationCategory.mention && !!n.contactId;

const isTasksDueNotification = (n: any) => {
  const message = n?.message?.toLowerCase() || "";
  return (
    n.type === NotificationCategory.task &&
    !n.meta?.eventType &&
    message.includes("tasks from") &&
    message.includes("buckets")
  );
};

const getTasksDueRoute = (notification: any) => {
  const bucketSlug = notification.meta?.bucketOptionSlug;
  if (bucketSlug) {
    return { name: BUCKETS_ROUTE, params: { bucket: bucketSlug }, query: { status: "due" } };
  }
  return { name: BUCKETS_LIST_ROUTE };
};

const handleViewEngagement = (notification: any) => {
  const taskType = ENGAGEMENT_EVENT_TO_TASK_TYPE[notification.meta?.eventType] || "call";

  openFollowupModal({
    contactId: notification.contactId,
    contactFname: notification.contact?.fname,
    contactLname: notification.contact?.lname,
    taskType,
    emailThreadId: notification.meta?.threadId || notification.meta?.emailId,
    chatId: notification.meta?.chatId,
  });
  closeDropdown();
};

const handleViewBucketPrompt = (notification: any) => {
  openFollowupModal({
    contactId: notification.contactId,
    contactFname: notification.contact?.fname,
    contactLname: notification.contact?.lname,
    taskType: "call",
  });
  closeDropdown();
};

const handleViewCueCards = (notification: any) => {
  openFollowupModal({
    contactId: notification.contactId,
    contactFname: notification.contact?.fname,
    contactLname: notification.contact?.lname,
    taskType: "email",
  });
  closeDropdown();
};

const handleViewMention = (notification: any) => {
  openFollowupModal({
    contactId: notification.contactId,
    contactFname: notification.contact?.fname,
    contactLname: notification.contact?.lname,
    taskType: "chat",
  });
  closeDropdown();
};

const showDropdown = ref(false);
const lastNotificationTimestamp = ref<number | null>(null);

const hideForRoutes = [SUBSCRIPTION_WALL_ROUTE, SUBSCRIPTION_SUCCESS_ROUTE];
const isHiddenRoute = computed(() => hideForRoutes.includes(props.route));

const selectedContact = ref<ContactSearchResult | null>(null);
const contactSearchTerm = ref("");
const debouncedContactSearch = ref("");
const contactFilterAnchorRef = ref<HTMLElement | null>(null);
const contactResultsPosition = ref({ top: 0, left: 0, width: 0 });

// The results popover is teleported to <body> (see template) so it can escape the
// notifications panel's `overflow: hidden` (needed there to clip the header/footer
// corners) instead of being cut off by it. Position it under the search box using
// its live bounding rect.
const updateContactResultsPosition = () => {
  const anchor = contactFilterAnchorRef.value;
  if (!anchor) return;
  const rect = anchor.getBoundingClientRect();
  contactResultsPosition.value = {
    top: rect.bottom + 4,
    left: rect.left,
    width: rect.width,
  };
};

const debouncedSetContactSearch = debounce((val: string) => {
  debouncedContactSearch.value = val;
}, 300);

const resetContactSearch = () => {
  debouncedSetContactSearch.cancel();
  contactSearchTerm.value = "";
  debouncedContactSearch.value = "";
};

watch(contactSearchTerm, (val) => {
  if (!val || val.length < 2) {
    debouncedSetContactSearch.cancel();
    debouncedContactSearch.value = "";
    return;
  }
  debouncedSetContactSearch(val);
});

watch(debouncedContactSearch, (val) => {
  if (val.length >= 2) {
    nextTick(updateContactResultsPosition);
  }
});

const contactSearchParams = computed(() => {
  if (!props.account?.organizationId || debouncedContactSearch.value.length < 2) return null;
  return {
    organizationId: props.account.organizationId,
    searchTerm: debouncedContactSearch.value,
    limit: 8,
    page: 1,
  };
});

const { data: contactSearchData, isFetching: isSearchingContacts } =
  useContacts(contactSearchParams);

const contactSearchResults = computed<ContactSearchResult[]>(
  () => contactSearchData.value?.data || []
);

const getContactName = (c: ContactSearchResult | null): string => {
  if (!c) return "Unknown";
  return c.fullName || `${c.fname || ""} ${c.lname || ""}`.trim() || c.name || "Unknown";
};

const getContactInitials = (c: ContactSearchResult): string => {
  const name = getContactName(c);
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return name.slice(0, 2).toUpperCase();
};

const selectContactFilter = (contact: ContactSearchResult) => {
  selectedContact.value = contact;
  resetContactSearch();
};

const clearContactFilter = () => {
  selectedContact.value = null;
};

// Filtering swaps in a different notification list — reset the "new notification"
// toast baseline so items that already existed under the new filter don't all fire
// toasts at once.
watch(selectedContact, () => {
  lastNotificationTimestamp.value = Date.now();
});

const notificationParams = computed(() => ({
  createdById: props.account?.id || null,
  organizationId: props.account?.organizationId || null,
  contactId: selectedContact.value?.id || null,
  limit: 15,
}));

const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage, refetch } =
  useNotifications(notificationParams);

const { mutate: markAsSeen } = useMarkNotificationSeen();

const notifications = computed(() => {
  if (!data.value?.pages) return [];
  return data.value.pages.flatMap((page) => page?.data || []);
});

const unseenCount = computed(() => {
  return notifications.value.filter((n) => !n.isSeen).length;
});

const closeDropdown = () => {
  showDropdown.value = false;
  document.removeEventListener("click", handleClickOutside);
  resetContactSearch();
};

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
  if (showDropdown.value) {
    setTimeout(() => {
      document.addEventListener("click", handleClickOutside);
    }, 0);
  } else {
    closeDropdown();
  }
};

const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as HTMLElement;
  if (!target.closest(".notifications-dropdown")) {
    closeDropdown();
  }
};

const loadMore = () => {
  if (!isFetchingNextPage.value && hasNextPage.value) {
    fetchNextPage();
  }
};

const markNotificationsAsSeen = () => {
  const unseenIds = notifications.value.filter((n) => !n.isSeen).map((n) => n.id);
  if (unseenIds.length > 0) {
    markAsSeen(unseenIds);
  }
};

const handleNotificationClick = (notification: any) => {
  if (!notification.isSeen) {
    markAsSeen([notification.id]);
  }
};

const isLinkedInConnectionRequest = (notification: any): boolean => {
  const message = notification?.message?.toLowerCase() || "";
  return (
    notification?.type === NotificationCategory.account &&
    !!notification?.contact &&
    message.includes("linkedin connection request")
  );
};

const getNotificationIcon = (notification: any) => {
  const type = notification?.type;
  const eventType = notification?.meta?.eventType;

  if (type === NotificationCategory.task && eventType) {
    const eventIconMap: Record<string, string> = {
      linkedin_connection: "mdi:linkedin",
      email_opened: "mdi:email-open-outline",
      email_clicked: "mdi:cursor-default-click",
      inmail_read: "mdi:linkedin",
      linkedin_message_read: "mdi:linkedin",
      whatsapp_message_read: "mdi:whatsapp",
      sms_received: "mdi:message-text",
      call_conversation: "mdi:phone",
      linkedin_message: "mdi:linkedin",
      whatsapp_message: "mdi:whatsapp",
      email_received: "mdi:email",
    };
    if (eventIconMap[eventType]) {
      return eventIconMap[eventType];
    }
  }

  if (type === NotificationCategory.task) {
    const message = notification?.message?.toLowerCase() || "";
    if (message.includes("call with") && message.includes("follow-up")) {
      return "mdi:phone-message";
    }
    if (message.includes("tasks from") && message.includes("buckets")) {
      return "mdi:checkbox-marked-circle-outline";
    }
    return "mdi:alert-circle";
  }

  if (isLinkedInConnectionRequest(notification)) {
    return "mdi:linkedin";
  }

  const categoryIconMap: Record<string, string> = {
    [NotificationCategory.enrichment]: "mdi:database-sync",
    [NotificationCategory.meeting]: "mdi:calendar-clock",
    [NotificationCategory.account]: "mdi:account-alert",
    [NotificationCategory.mention]: "mdi:at",
  };
  return categoryIconMap[type] || "mdi:bell-outline";
};

const getNotificationTypeClass = (notification: any) => {
  const type = notification?.type;
  const eventType = notification?.meta?.eventType;

  if (type === NotificationCategory.task && eventType) {
    const eventClassMap: Record<string, string> = {
      linkedin_connection: "type-linkedin",
      email_opened: "type-email",
      email_clicked: "type-email",
      inmail_read: "type-linkedin",
      linkedin_message_read: "type-linkedin",
      whatsapp_message_read: "type-whatsapp",
      sms_received: "type-sms",
      call_conversation: "type-call",
      linkedin_message: "type-linkedin",
      whatsapp_message: "type-whatsapp",
      email_received: "type-email",
    };
    if (eventClassMap[eventType]) {
      return eventClassMap[eventType];
    }
  }

  if (type === NotificationCategory.task) {
    const message = notification?.message?.toLowerCase() || "";
    if (message.includes("call with") && message.includes("follow-up")) {
      return "type-call-followup";
    }
    return "type-task";
  }

  const message = notification?.message?.toLowerCase() || "";
  if (
    type === NotificationCategory.ai_generation ||
    message.includes("cue cards") ||
    message.includes("outreach cue")
  ) {
    return "type-ai";
  }

  if (isLinkedInConnectionRequest(notification)) {
    return "type-linkedin";
  }

  const classMap: Record<string, string> = {
    [NotificationCategory.enrichment]: "type-enrichment",
    [NotificationCategory.meeting]: "type-meeting",
    [NotificationCategory.account]: "type-account",
    [NotificationCategory.mention]: "type-mention",
  };
  return classMap[type] || "type-default";
};

const getNotificationTitle = (notification: any) => {
  if (!notification?.type) return "Notification";

  if (notification.type === NotificationCategory.enrichment) {
    return "Data Enrichment";
  }

  if (notification.type === NotificationCategory.ai_generation) {
    return "AI Outreach";
  }

  if (notification.type === NotificationCategory.meeting) {
    if (notification.meta?.eventType === "attendee_rsvp") {
      return "Meeting RSVP Update";
    }
    return "Meeting Reminder";
  }

  if (notification.type === NotificationCategory.mention) {
    return "Mentioned in Chat";
  }

  if (notification.type === NotificationCategory.account) {
    const message = notification.message?.toLowerCase() || "";
    if (isLinkedInConnectionRequest(notification)) {
      return "New LinkedIn Connection";
    }
    if (message.includes("deleted")) return "Account Deleted";
    if (message.includes("reconnect") || message.includes("disconnected"))
      return "Account Connection";
    return "Account Update";
  }

  if (notification.type === NotificationCategory.task) {
    const eventType = notification.meta?.eventType;

    if (eventType) {
      const eventTitleMap: Record<string, string> = {
        linkedin_message: "New LinkedIn Message",
        whatsapp_message: "New WhatsApp Message",
        email_received: "New Email",
        sms_received: "New SMS",
        call_conversation: "Call Completed",
        email_opened: "Email Opened",
        email_clicked: "Email Link Clicked",
        linkedin_connection: "Connection Accepted",
        inmail_read: "InMail Read",
        linkedin_message_read: "LinkedIn Message Read",
        whatsapp_message_read: "Message Read",
      };
      if (eventTitleMap[eventType]) {
        return eventTitleMap[eventType];
      }
    }

    const message = notification.message?.toLowerCase() || "";
    if (message.includes("tasks from") && message.includes("buckets")) return "Tasks Due";
    if (message.includes("call with")) return "Call Follow-up";
    return "Action Required";
  }

  return "Notification";
};

const buildLinkRoute = (linkUrl: string, notification?: any) => {
  const url = new URL(linkUrl, window.location.origin);
  const query: Record<string, string> = Object.fromEntries(url.searchParams);
  if (route.query.owner) query.owner = route.query.owner as string;

  const followUpDate = notification?.meta?.followUpDate;
  if (followUpDate && !query.status) {
    const now = new Date();
    const todayKey = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
    if (followUpDate < todayKey) query.status = "past";
    else if (followUpDate === todayKey) query.status = "due";
    else query.status = "future";
  }

  return { path: url.pathname, query };
};

const getEnrichmentViewRoute = (notification: any) => {
  const contactIds = notification.meta?.contactIds;

  // Single contact — go to contact overview
  if (contactIds?.length === 1) {
    return { name: CONTACT_OVERVIEW_ROUTE, params: { id: contactIds[0] } };
  }

  // Multiple contacts — filter by exact IDs
  if (contactIds?.length > 1) {
    return { name: CONTACTS_ROUTE, query: { contactIds: contactIds.join(",") } };
  }

  // Fallback: filter by date
  const createdAt = new Date(notification.createdAt);
  if (isNaN(createdAt.getTime())) {
    return { name: CONTACTS_ROUTE };
  }
  const startOfDay = new Date(createdAt);
  startOfDay.setHours(0, 0, 0, 0);
  const endOfDay = new Date(createdAt);
  endOfDay.setHours(23, 59, 59, 999);

  return {
    name: CONTACTS_ROUTE,
    query: {
      startDate: startOfDay.toISOString(),
      endDate: endOfDay.toISOString(),
    },
  };
};

const showNotificationToast = (notification: any) => {
  const title = getNotificationTitle(notification);
  const message = notification.message;
  const contactName = notification.contact
    ? [notification.contact.fname, notification.contact.lname].filter(Boolean).join(" ") || null
    : null;
  const meetingTitle = notification.meeting?.title;

  let toastMessage = message;
  if (contactName) {
    toastMessage = `${title}: ${message} - ${contactName}`;
  } else if (meetingTitle) {
    toastMessage = `${title}: ${message} - ${meetingTitle}`;
  } else {
    toastMessage = `${title}: ${message}`;
  }

  const toastType =
    notification.type === NotificationCategory.task ||
    notification.type === NotificationCategory.account
      ? "warning"
      : "info";

  $toast?.[toastType](toastMessage, {
    duration: 5000,
  });
};

watch(showDropdown, (isOpen) => {
  if (isOpen) {
    markNotificationsAsSeen();
    window.addEventListener("resize", updateContactResultsPosition);
    window.addEventListener("scroll", updateContactResultsPosition, true);
  } else {
    window.removeEventListener("resize", updateContactResultsPosition);
    window.removeEventListener("scroll", updateContactResultsPosition, true);
  }
});

watch(
  notifications,
  (newNotifications, oldNotifications) => {
    if (!newNotifications || !Array.isArray(newNotifications)) return;

    if (!lastNotificationTimestamp.value && newNotifications.length > 0) {
      const latest = newNotifications[0];
      if (latest?.createdAt) {
        lastNotificationTimestamp.value = new Date(latest.createdAt).getTime();
      }
      return;
    }

    if (oldNotifications && Array.isArray(oldNotifications)) {
      newNotifications.forEach((notification) => {
        const notificationTime = new Date(notification.createdAt).getTime();
        const isNew = !oldNotifications.find((old) => old.id === notification.id);
        const isUnseen = !notification.isSeen;

        if (isNew && isUnseen && notificationTime > (lastNotificationTimestamp.value || 0)) {
          showNotificationToast(notification);
          lastNotificationTimestamp.value = Math.max(
            lastNotificationTimestamp.value || 0,
            notificationTime
          );
        }
      });
    }
  },
  { deep: true }
);

onMounted(() => {
  if (notifications.value.length > 0) {
    const latest = notifications.value[0];
    if (latest?.createdAt) {
      lastNotificationTimestamp.value = new Date(latest.createdAt).getTime();
    }
  }
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
  debouncedSetContactSearch.cancel();
  window.removeEventListener("resize", updateContactResultsPosition);
  window.removeEventListener("scroll", updateContactResultsPosition, true);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!isHiddenRoute.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["notification-wrapper", { 'has-new-notifications': unseenCount.value > 0 }]),
            onClick: toggleDropdown
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Icon), {
                icon: "mdi:bell",
                width: "18",
                height: "18"
              }),
              (unseenCount.value > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(unseenCount.value > 99 ? "99+" : unseenCount.value), 1))
                : _createCommentVNode("", true)
            ])
          ], 2),
          (showDropdown.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "notifications-dropdown",
                onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[8] || (_cache[8] = _createElementVNode("h6", { class: "notifications-title" }, "Notifications", -1)),
                  (unseenCount.value > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(unseenCount.value), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (selectedContact.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, [
                          (selectedContact.value.profilePictureUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: selectedContact.value.profilePictureUrl,
                                alt: getContactName(selectedContact.value),
                                class: "contact-filter-chip__avatar-img"
                              }, null, 8, _hoisted_10))
                            : (_openBlock(), _createBlock(_unref(Icon), {
                                key: 1,
                                icon: "mdi:account",
                                width: "12",
                                height: "12"
                              }))
                        ]),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(getContactName(selectedContact.value)), 1),
                        _createElementVNode("button", {
                          class: "contact-filter-chip__clear",
                          "aria-label": "Clear contact filter",
                          onClick: clearContactFilter
                        }, [
                          _createVNode(_unref(Icon), {
                            icon: "mdi:close",
                            width: "14",
                            height: "14"
                          })
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        ref_key: "contactFilterAnchorRef",
                        ref: contactFilterAnchorRef,
                        class: "contact-filter-search-wrapper"
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_unref(Icon), {
                            icon: "mdi:magnify",
                            width: "15",
                            height: "15",
                            class: "contact-filter-search__icon"
                          }),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contactSearchTerm).value = $event)),
                            class: "contact-filter-search__input",
                            placeholder: "Filter by contact..."
                          }, null, 512), [
                            [_vModelText, contactSearchTerm.value]
                          ]),
                          (_unref(isSearchingContacts))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                          (debouncedContactSearch.value.length >= 2)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "contact-filter-results",
                                style: _normalizeStyle({
                  top: `${contactResultsPosition.value.top}px`,
                  left: `${contactResultsPosition.value.left}px`,
                  width: `${contactResultsPosition.value.width}px`,
                }),
                                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                (!_unref(isSearchingContacts) && contactSearchResults.value.length === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No contacts found "))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactSearchResults.value, (result) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: result.id,
                                    class: "contact-filter-result-item",
                                    onClick: ($event: any) => (selectContactFilter(result))
                                  }, [
                                    _createElementVNode("span", _hoisted_16, [
                                      (result.profilePictureUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: result.profilePictureUrl,
                                            alt: getContactName(result),
                                            class: "contact-filter-result-item__avatar-img"
                                          }, null, 8, _hoisted_17))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(_toDisplayString(getContactInitials(result)), 1)
                                          ], 64))
                                    ]),
                                    _createElementVNode("span", _hoisted_18, [
                                      _createElementVNode("span", _hoisted_19, _toDisplayString(getContactName(result)), 1),
                                      (result.email)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(result.email), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 8, _hoisted_15))
                                }), 128))
                              ], 4))
                            : _createCommentVNode("", true)
                        ]))
                      ], 512))
                ]),
                (_unref(isLoading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(LoadingBars, { size: "sm" })
                    ]))
                  : (notifications.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (notification) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: notification.id,
                            class: _normalizeClass(["notification-item", { unread: !notification.isSeen }]),
                            onClick: ($event: any) => (handleNotificationClick(notification))
                          }, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["notification-type-icon", getNotificationTypeClass(notification)])
                              }, [
                                _createVNode(_unref(Icon), {
                                  icon: getNotificationIcon(notification),
                                  width: "20",
                                  height: "20"
                                }, null, 8, ["icon"])
                              ], 2),
                              (!notification.isSeen)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("h6", {
                                  class: _normalizeClass(["notification-title", { 'unread-text': !notification.isSeen }])
                                }, _toDisplayString(getNotificationTitle(notification)), 3),
                                _createElementVNode("p", {
                                  class: _normalizeClass(["notification-message-text", { 'unread-text': !notification.isSeen }])
                                }, _toDisplayString(notification.message), 3),
                                (notification.contact)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      _createVNode(_unref(Icon), {
                                        icon: "mdi:account",
                                        width: "14",
                                        height: "14"
                                      }),
                                      _createElementVNode("span", null, _toDisplayString([notification.contact.fname, notification.contact.lname]
                      .filter(Boolean)
                      .join(" ") || "Contact"), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (notification.meeting)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      _createVNode(_unref(Icon), {
                                        icon: "mdi:calendar",
                                        width: "14",
                                        height: "14"
                                      }),
                                      _createElementVNode("span", null, _toDisplayString(notification.meeting.title), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("small", _hoisted_31, _toDisplayString(formatNotificationTime(notification.createdAt)), 1),
                                _createElementVNode("div", _hoisted_32, [
                                  (isEngagementNotification(notification))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "notification-action-link",
                                        onClick: _withModifiers(($event: any) => (handleViewEngagement(notification)), ["stop"])
                                      }, " View ", 8, _hoisted_33))
                                    : (isBucketPromptNotification(notification))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          class: "notification-action-link",
                                          onClick: _withModifiers(($event: any) => (handleViewBucketPrompt(notification)), ["stop"])
                                        }, " View ", 8, _hoisted_34))
                                      : (isCueCardsNotification(notification))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 2,
                                            class: "notification-action-link",
                                            onClick: _withModifiers(($event: any) => (handleViewCueCards(notification)), ["stop"])
                                          }, " View ", 8, _hoisted_35))
                                        : (isMentionNotification(notification))
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 3,
                                              class: "notification-action-link",
                                              onClick: _withModifiers(($event: any) => (handleViewMention(notification)), ["stop"])
                                            }, " View ", 8, _hoisted_36))
                                          : (isTasksDueNotification(notification))
                                            ? (_openBlock(), _createBlock(_component_router_link, {
                                                key: 4,
                                                to: getTasksDueRoute(notification),
                                                class: "notification-action-link",
                                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showDropdown.value = false), ["stop"]))
                                              }, {
                                                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                                  _createTextVNode(" View ", -1)
                                                ]))]),
                                                _: 1
                                              }, 8, ["to"]))
                                            : (notification.linkUrl && notification.type !== 'enrichment')
                                              ? (_openBlock(), _createBlock(_component_router_link, {
                                                  key: 5,
                                                  to: buildLinkRoute(notification.linkUrl, notification),
                                                  class: "notification-action-link",
                                                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showDropdown.value = false), ["stop"]))
                                                }, {
                                                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                    _createTextVNode(" View ", -1)
                                                  ]))]),
                                                  _: 1
                                                }, 8, ["to"]))
                                              : (
                      notification.type === 'enrichment' && notification.meta?.contactIds?.length
                    )
                                                ? (_openBlock(), _createBlock(_component_router_link, {
                                                    key: 6,
                                                    to: getEnrichmentViewRoute(notification),
                                                    class: "notification-action-link",
                                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showDropdown.value = false), ["stop"]))
                                                  }, {
                                                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                      _createTextVNode(" View ", -1)
                                                    ]))]),
                                                    _: 1
                                                  }, 8, ["to"]))
                                                : (notification.contactId)
                                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                                      key: 7,
                                                      to: { name: _unref(CONTACT_OVERVIEW_ROUTE), params: { id: notification.contactId } },
                                                      class: "notification-action-link",
                                                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (showDropdown.value = false), ["stop"]))
                                                    }, {
                                                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                        _createTextVNode(" View ", -1)
                                                      ]))]),
                                                      _: 1
                                                    }, 8, ["to"]))
                                                  : (notification.meetingId)
                                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                                        key: 8,
                                                        to: {
                      name: _unref(MEETINGS_ROUTE),
                      query: { status: 'all', toOpenMeetingId: notification.meetingId },
                    },
                                                        class: "notification-action-link",
                                                        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (showDropdown.value = false), ["stop"]))
                                                      }, {
                                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                          _createTextVNode(" View ", -1)
                                                        ]))]),
                                                        _: 1
                                                      }, 8, ["to"]))
                                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ], 10, _hoisted_23))
                        }), 128)),
                        (_unref(hasNextPage))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _createElementVNode("button", {
                                class: "load-more-btn",
                                disabled: _unref(isFetchingNextPage),
                                onClick: _withModifiers(loadMore, ["stop"])
                              }, [
                                (_unref(isFetchingNextPage))
                                  ? (_openBlock(), _createBlock(_unref(Icon), {
                                      key: 0,
                                      icon: "mdi:loading",
                                      class: "spin",
                                      width: "14",
                                      height: "14"
                                    }))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", null, _toDisplayString(_unref(isFetchingNextPage) ? "Loading..." : "Show older notifications"), 1)
                              ], 8, _hoisted_38)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createVNode(_unref(Icon), {
                          icon: "mdi:bell-off-outline",
                          width: "36",
                          height: "36"
                        }),
                        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-center" }, "No notifications", -1))
                      ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})